import { PopoverActions } from "@mui/material";
import React, { RefObject } from "react";
import { useWidgetConfigContext } from "src/contexts/widgetConfig/WidgetConfig.context";
import {
  useUbicationFilterContext,
  zoneI,
} from "../../../../../../hooks/UbicationFilterContext";
import DefaultLocationDropdown from "./components/DefaultLocationDropdown";
import NestedLocationDropdown from "./components/NestedLocationDropdown";

export interface LocationDropdownProps {
  ubicationFilterList: zoneI[];
  onSelect: (zone: zoneI) => void;
  popoverActionRef?: RefObject<PopoverActions>;
}

const LocationDropdown = ({
  onSelectUbication,
  popoverActionRef,
}: {
  onSelectUbication: (ubication: zoneI) => void;
  popoverActionRef?: RefObject<PopoverActions>;
}) => {
  const { locationDropdownDesign } = useWidgetConfigContext();
  const { ubicationFilterList } = useUbicationFilterContext();

  if (locationDropdownDesign === "nestedDropdown")
    return (
      <NestedLocationDropdown
        ubicationFilterList={ubicationFilterList}
        onSelect={onSelectUbication}
        popoverActionRef={popoverActionRef}
      />
    );

  return (
    <DefaultLocationDropdown
      ubicationFilterList={ubicationFilterList}
      onSelect={onSelectUbication}
    />
  );
};
export default LocationDropdown;
